/* Shto swipe: carousels that never take the page's scroll.
   A native sideways scroller ([data-shto-carousel], overflow-x: auto) can capture a vertical swipe or a trackpad gesture
   that starts over it, most of all while the page is still gliding or when the swipe is slightly diagonal, and the page
   stops until the finger lifts (Kevin 2026-09-23, Myoxcience). Blushe's own sliders don't do this because a script moves them.
   Same here: once this runs, the carousel is overflow: hidden (the browser can't scroll it, so every up-down gesture
   goes to the page), touch-action: pan-y, and a sideways drag moves it with scrollLeft. Arrows, thumbnails, dots and
   progress bars keep working because they already read and set scrollLeft.
   data-shto-carousel="snap": a flick moves one item (or more for a long drag) and settles on an item's start.
   data-shto-carousel="free": it follows the finger and stops where released (thumbnail strips).
   data-shto-wrap (with "snap"): a swipe past the last item goes back to the first, and past the first to the last.
   Mouse/trackpad screens only (client choice 2026-10-07): on phones and tablets the carousels are the browser's own
   scroll with snap points (assets/shto-base.css), which is smoother; the script leaves them alone there. */
(function () {
  if (window.ShtoSwipe) return;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)'); // same test as the CSS in shto-base.css
  window.ShtoSwipe = { init: function (root) { initAll(root); }, jump: jump }; // call ShtoSwipe.init(el) after adding a carousel with script

  // A wrap (last -> first or first -> last): jump straight there and slide the new item in from the side it comes from,
  // instead of a smooth scroll racing past every item in between. dir 1 = forward (comes in from the right), -1 = back.
  function jump(el, left, dir) {
    el.scrollTo({ left: left, behavior: 'auto' });
    if (!el.animate || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var from = (dir > 0 ? 1 : -1) * Math.min(80, el.clientWidth * 0.2);
    var list = items(el), base = list.length ? list[0].offsetLeft : 0;
    var hits = list.filter(function (c) { return Math.abs(Math.min(maxLeft(el), c.offsetLeft - base) - el.scrollLeft) < 2; });
    var item = hits[0] || list[dir > 0 ? 0 : list.length - 1];
    if (!item) return;
    item.animate([{ transform: 'translateX(' + from + 'px)', opacity: 0.35 }, { transform: 'translateX(0)', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
  }

  function items(el) { return Array.prototype.filter.call(el.children, function (c) { return c.offsetWidth > 0; }); }
  function maxLeft(el) { return Math.max(0, el.scrollWidth - el.clientWidth); }
  // Where the carousel rests: each item's distance from the first item (the container's own padding stays in front).
  function stops(el) {
    var list = items(el), base = list.length ? list[0].offsetLeft : 0, max = maxLeft(el);
    var out = list.map(function (c) { return Math.min(max, Math.max(0, c.offsetLeft - base)); });
    out.push(max);
    return out.filter(function (v, i, a) { return a.indexOf(v) === i; }).sort(function (x, y) { return x - y; });
  }

  function init(el) {
    if (el.shtoSwipe) return;
    el.shtoSwipe = true;
    el.setAttribute('data-shto-swipe-on', '');
    var free = el.getAttribute('data-shto-carousel') === 'free';
    var wrap = el.hasAttribute('data-shto-wrap');
    var drag = null, suppressClick = false;

    el.addEventListener('pointerdown', function (event) {
      if (!fine.matches) return; // phones and tablets: native scrolling
      if (event.button !== undefined && event.button !== 0) return;
      if (maxLeft(el) < 1) return;
      drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: el.scrollLeft, t: event.timeStamp, lastX: event.clientX, lastT: event.timeStamp, v: 0, on: false };
      suppressClick = false;
    });
    el.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id) return;
      var dx = event.clientX - drag.x, dy = event.clientY - drag.y;
      if (!drag.on) {
        if (Math.abs(dy) > 8 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; } // an up-down swipe: the page's
        if (Math.abs(dx) < 8) return;
        drag.on = true;
        try { el.setPointerCapture(event.pointerId); } catch (e) {}
      }
      var dt = Math.max(event.timeStamp - drag.lastT, 1);
      drag.v = (event.clientX - drag.lastX) / dt;
      drag.lastX = event.clientX; drag.lastT = event.timeStamp;
      drag.dx = dx;
      el.scrollLeft = drag.left - dx;
    });
    function end(event) {
      if (!drag || (event && event.pointerId !== drag.id)) return;
      var d = drag; drag = null;
      if (!d.on) return;
      suppressClick = true;
      var moved = d.left - el.scrollLeft; // negative when dragged left (moving forward)
      var target;
      if (free) {
        target = Math.min(maxLeft(el), Math.max(0, el.scrollLeft - d.v * 180));
      } else {
        var s = stops(el), here = el.scrollLeft, i = 0;
        while (i < s.length - 1 && s[i + 1] <= d.left + 1) i++;
        var forward = d.v < -0.2 || (d.v <= 0.2 && moved < -el.clientWidth * 0.15);
        var back = d.v > 0.2 || (d.v >= -0.2 && moved > el.clientWidth * 0.15);
        var last = s[s.length - 1];
        // Wrap: judged on the finger, since the row can't move past its ends.
        var pushFwd = d.v < -0.2 || (d.dx || 0) < -el.clientWidth * 0.15;
        var pushBack = d.v > 0.2 || (d.dx || 0) > el.clientWidth * 0.15;
        if (wrap && pushFwd && d.left >= last - 1) return jump(el, s[0], 1);
        if (wrap && pushBack && d.left <= s[0] + 1) return jump(el, last, -1);
        if (forward) { var j = i; while (j < s.length - 1 && s[j] <= here + 1) j++; target = s[j]; }
        else if (back) { var k = i; while (k > 0 && s[k] >= here - 1) k--; target = s[k]; }
        else target = s.reduce(function (a, b) { return Math.abs(b - here) < Math.abs(a - here) ? b : a; }, s[0]);
      }
      el.scrollTo({ left: target, behavior: 'smooth' });
    }
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', function (event) { if (drag && event.pointerId === drag.id) drag = null; });
    // On touch the browser has already captured the pointer to the child under the finger; taking it for the row makes
    // that child fire lostpointercapture, which bubbles up here. Only the row's own loss ends a drag, or a slow swipe
    // would snap one item after 8px instead of following the finger.
    el.addEventListener('lostpointercapture', function (event) { if (event.target === el) end(event); });
    el.addEventListener('click', function (event) { if (suppressClick) { event.preventDefault(); event.stopPropagation(); suppressClick = false; } }, true);
    el.addEventListener('dragstart', function (event) { event.preventDefault(); });
  }

  function initAll(root) { (root || document).querySelectorAll('[data-shto-carousel]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
